import { allAdventureGalleries } from '@/data/adventureGalleries';
import awsReinvent from '@/data/reckon-way/events/conferences/awsReinvent';
import { cultureStories } from './stories';

const galleryCategory = (gallery = {}) => {
  if (gallery.meta === 'Corporate Retreat') return 'Retreats';
  if (gallery.meta === 'Conference') return 'Conferences';
  return 'Traditions';
};

const firstPostImage = (post = {}, gallery = {}) => (
  post.image
  || post.heroImage
  || (post.images || [])[0]?.src
  || (post.sections || []).flatMap((section) => section.images || [])[0]?.src
  || gallery.heroImage
  || gallery.coverImage
);

const cultureNarratives = cultureStories.map((story) => ({
  id: `culture-${story.id}`,
  title: story.title,
  excerpt: story.excerpt,
  image: story.image,
  imageAlt: story.imageAlt,
  category: 'Culture',
  source: story.badge || 'The Reckon Way',
  dateLabel: story.publishedAt?.slice(0, 4) || '',
  href: { name: 'reckon-way-culture-story', params: { storySlug: story.slug } },
  featured: story.featured === true,
  featuredPriority: story.featuredPriority ?? Number.MAX_SAFE_INTEGER,
}));

const journeyNarratives = allAdventureGalleries.flatMap((gallery) => {
  if (gallery.storiesComingSoon) return [];

  return (gallery.blogPosts || [])
    .filter((post) => post.released === true)
    .map((post) => ({
      id: `${gallery.slug}-${post.slug}`,
      title: post.title,
      excerpt: post.lede || post.summary || gallery.description,
      image: firstPostImage(post, gallery),
      imageAlt: `${post.title} from ${gallery.title}`,
      category: galleryCategory(gallery),
      source: gallery.title,
      dateLabel: post.dayLabel || gallery.dateLabel || gallery.tripCard?.date || '',
      href: {
        name: 'reckon-way-story',
        params: { gallerySlug: gallery.slug, storySlug: post.slug },
      },
      featured: false,
      featuredPriority: Number.MAX_SAFE_INTEGER,
    }));
});

const awsNarrativeSpecs = [
  {
    title: 'ATV Tour in the Mojave Desert',
    year: 2022,
    cardTitle: 'ATVs in the Mojave Desert',
  },
  {
    title: 'UTV Tour in the Mojave Desert',
    year: 2023,
    cardTitle: 'UTVs in the Mojave Desert',
  },
  {
    title: 'Hiking Zion National Park',
    year: 2024,
    cardTitle: 'Zion National Park',
  },
];

const awsNarratives = awsNarrativeSpecs.map((spec) => {
  const activity = (awsReinvent.activities || [])
    .find((item) => item.title === spec.title && item.year === spec.year) || {};
  const entityId = activity.entityId
    || `${spec.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}-${spec.year}`;

  return {
    id: `aws-reinvent-${entityId}`,
    title: spec.cardTitle,
    excerpt: activity.whatWeRemember || activity.description,
    image: activity.images?.[0]?.src || awsReinvent.heroImage,
    imageAlt: activity.images?.[0]?.alt || `${spec.cardTitle} during AWS re:Invent`,
    category: 'Conferences',
    source: 'AWS re:Invent',
    dateLabel: String(spec.year),
    href: {
      name: 'reckon-way-entity',
      params: {
        gallerySlug: awsReinvent.slug,
        sectionKey: 'activities',
        entityId,
      },
    },
    featured: false,
    featuredPriority: Number.MAX_SAFE_INTEGER,
  };
});

export const publishedNarratives = [
  ...cultureNarratives,
  ...awsNarratives,
  ...journeyNarratives,
];

export default publishedNarratives;
